import {CurrencyDefinition, CustomerInfo, PaymentDialog, PaymentMethod, Settings, UserInfo} from "../../http/protocol";
import {PaymentStateStatus} from "../../payments/PaymentsReducer";
import React, { useEffect, useState } from "react";
import {connect} from "react-redux";
import {AppState} from "../../RootReducer";
import {Dispatch} from "redux";
import {initDeposit, initStorePurchase} from "../../payments/DepositActions";
import QRCode from "qrcode";
import {Spinner} from "../Spinner";
import "./styles/Deposit.scss";
import {ContentModelName, OnboardingPagePayload} from "../../contenful/types";
import {fetchContent} from "../../contenful/ContentfulActions";
import {t} from "../../i18n";
import UserIdentificationForm from "./UserIdentificationForm";
import CoinpaymentsDepositComponent from "./providerComponents/CoinpaymentsDepositComponent";
import {Redirect} from "react-router";
import {reset} from "../../payments/PaymentsActions";
import {OpenInNewWindow} from "./OpenInNewWindow";
import CurrencyFormatter from "../../utils/CurrencyFormatter";


function LoadingText({text}: {text: string}) {
    return (<span>{text}</span>)
}

interface Props  {
    dialog? : PaymentDialog,
    status? : PaymentStateStatus
    initDeposit? :() => void;
    initStorePurchase?: (bundleId?: number) => void;
    fetchContent: typeof fetchContent;
    onboardingPage? : OnboardingPagePayload;
    settings? : Settings;
    bundleId?: number;
    changePaymentProvider: typeof reset;
    user?: UserInfo;
    activeMethod? : PaymentMethod;
}

interface State {
    termsNotApproved: boolean;
    cancel: boolean;
}

export class DepositProviderContent extends React.Component<Props, State>{
    constructor(props:Props) {
        super(props);
        this.state = {termsNotApproved:true, cancel: false}
    }


    componentDidMount(): void {
        window.addEventListener('message', (e) => {
            if(e.data == "expay.iframe.close") {
                this.setState({cancel:true});
            }
        });
        if(this.props.status == PaymentStateStatus.NONE) {
            if(this.props.settings&& this.props.settings.useStoreInsteadOfDeposit) {
                // this is handled in PaymentProviderButtonDeposit
                // this.props.initStorePurchase && this.props.initStorePurchase(this.props.bundleId);
            } else {
                this.props.initDeposit && this.props.initDeposit();
            }
        }
        if(this.props.onboardingPage == undefined) {
            this.props.fetchContent(ContentModelName.ONBOARDINGPAGE);
        }
    }
    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
        if((this.props.status != prevProps.status && this.props.status == PaymentStateStatus.NONE)) {
            if(this.props.settings&& this.props.settings.useStoreInsteadOfDeposit) {
                // this is handled in the PaymentProviderButtonDeposit
                // this.props.initStorePurchase && this.props.initStorePurchase();
            } else {
                this.props.initDeposit && this.props.initDeposit();
            }
        }
    }

    close() {
    }

    render() {
        if(this.state.cancel == true) {
            return <Redirect to={"/"} />
        }
        let props = this.props;
        let customerInfo: CustomerInfo = props.dialog && props.dialog.payment && props.dialog.payment.order && props.dialog.payment.order.customerInfo ? props.dialog.payment.order.customerInfo : {};
        let dialog = props.dialog;
        let provider = dialog && dialog.payment && dialog.payment.provider;
        let method = dialog?.payment?.attributes?.["PAYMENT_METHOD"]
        let firstName = customerInfo.firstName ? customerInfo.firstName[0].toUpperCase() + customerInfo.firstName.slice(1) : "";
        let lastName = customerInfo.lastName ? customerInfo.lastName[0].toUpperCase() + customerInfo.lastName.slice(1) : "";
        let email = customerInfo.email ? customerInfo.email : "";
        let phone = customerInfo.phone ? customerInfo.phone : "";
        let isStore = props.settings && props.settings.useStoreInsteadOfDeposit;
        if(props.status != PaymentStateStatus.DEPOSIT_INITIALIZED ) {
            return (
                <div className="loading-address" style={{height : "200px"}}>
                    <LoadingText text={t("global.addressLoadingText")}/>
                    <Spinner/>
                </div>
            )
        } else {
            let decimals: number = 0;
            if(props.user && props.user.currencies) {
                props.user.currencies.forEach((cd:CurrencyDefinition) => {
                    if(cd.fractionalDigits && props.dialog && props.dialog.payment && cd.code == props.dialog.payment.currency) {
                        decimals = cd.fractionalDigits;
                    }
                })
            }
            console.log("LOADING IFRAME =", dialog?.iframeUrl, dialog?.openInNewWindow);
            console.log(">>>>>>>>>>> dialog: ", dialog)
            return (
                <div>
                    {dialog && dialog.iframeUrl && !dialog.openInNewWindow && (provider != 'coinpayments') && <iframe className={"payment-provider-iframe"} frameBorder={0} src={dialog.iframeUrl} width={"100%"} height={"200px"}/>}
                    {dialog && dialog.iframeUrl && dialog.openInNewWindow && (provider != 'coinpayments') && <OpenInNewWindow url={dialog.iframeUrl} />}
                    {dialog && dialog.iframeUrl && !dialog.openInNewWindow && provider == 'coinpayments' && <CoinpaymentsDepositComponent isIframe={true} url={dialog.iframeUrl} isStore={isStore}/>}
                    {dialog && !dialog.openInNewWindow && dialog.customContext && dialog.customContext.address && dialog.payment && dialog.payment.currency && props.onboardingPage && (
                        <CryptoDeposit address={dialog.customContext.address} currency={dialog.payment.currency} decimals={decimals} warningText={t("payments.maxDecimalsWarning")}/>
                    )}
                    {provider == 'maya'  &&  method == 'MAYA_ONE_TIME_WALLET_QRPH'  &&
                        <MayaQRPHDeposit qrText={dialog?.customContext['qrCodeBody']} redirectUrl={dialog?.customContext['redirectUrl']}></MayaQRPHDeposit>
                    }
                    <UserIdentificationForm initialValues={{firstName:firstName, lastName:lastName, email:email, phone: phone, bank: {accountCountry:'US'}}}/>
                </div>
            )
        }
    }
};
export function copyToClipboard(elementId : string) {
    let el = document.getElementById(elementId);
    if(el) {
        let body = document.body as any;
        let range:any;
        if (body .createTextRange) {
            range = body.createTextRange();
            range.moveToElementText(el);
            range.select();
        } else if (window.getSelection) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(el);
            if(selection) {
                selection.removeAllRanges();
                selection.addRange(range);
            }
        }
        document.execCommand('copy');
        const sel = window && window.getSelection();
        if(sel) {sel.removeAllRanges()}
    }
}

export const MayaQRPHDeposit = (props : {qrText: string, redirectUrl: string}) => {

    const [qr, setQr] = useState<string | undefined>(undefined)

    useEffect(() =>{
        QRCode.toDataURL(props.qrText).then(d => {
            setQr(d);
        })
    }, [props.qrText])

    return (
        <div className="crypto-deposit-container">
            <div className="text">
                {t('payments.method.maya_one_time_wallet_qrph.scan-qr-heading')}
            </div>
            <div className="crypto-qr-container">
                <a href={props.redirectUrl} target="_blank">
                    <img src={qr}/>
                </a>
            </div>
        </div>
    )
}

export const CryptoDeposit = (props : { address : string, currency : string, decimals : number, warningText : string}) => {
    return (
        <div className={"crypto-deposit-container"}>
           <div className={"text"}>{t("payments.address").replace("|currency|", props.currency)}</div>
            <div className={"crypto-qr-container"}><OldCryptoQR address={props.address}/></div>
            <div className={"form-control crypto-address"}>
                <span className={"address"} id={"cryptoAddress"}>{props.address}</span>
                <i className={"material-icons"} onClick={()=> copyToClipboard("cryptoAddress")}>content_copy</i>
            </div>
            {/*<span className="text-warning">{props.warningText != undefined ? `${props.warningText}: ${props.decimals}` : ""}</span>*/}
        </div>
    )
}
interface CryptoQRProps {
    address : string;
}
export class OldCryptoQR extends React.Component<CryptoQRProps, {data? : string}>{
    constructor(props : CryptoQRProps) {
        super(props);
        this.state = { }
    }
    componentDidMount(): void {
        QRCode.toDataURL(this.props.address).then( d =>{
            this.setState({data : d});
        })
    }
    render() {
        if(!this.state.data) {
            return <span></span>
        }
        return  <img alt={"provider"} src={this.state.data} />
    }

}
const mapStateToProps = (app: AppState)=> ({
    dialog : app.payments.deposit.depositDialog,
    status : app.payments.deposit.status,
    global : app.contentful.global,
    onboardingPage : app.contentful.onboardingpage,
    settings : app.settings.settings,
    bundleId: app.store.selectedBundleId,
    user : app.user.user,
    method : app.payments.deposit.activeMethod
});
const mapDispatchToProps = (dispatch : Dispatch) => ({
    initDeposit : ()=>dispatch(initDeposit() as any),
    initStorePurchase : (bundleId?: number)=>dispatch(initStorePurchase(bundleId) as any),
    fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
    changePaymentProvider: ()=>dispatch(reset() as any)
})
export default connect(mapStateToProps,mapDispatchToProps)(DepositProviderContent)